module.exports = __webpack_public_path__ + "static/img/110.49667fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/110.png
// module id = MEzq
// module chunks = 0